import styled from 'styled-components';
import { cssColorValue, screenXsMax } from '@spotify-internal/encore-web';
import { WarningMessage } from 'components/WarningMessage';

export const CancelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 400px;
  padding: 70px;
  text-align: center;
  background: ${cssColorValue('backgroundBase')};
`;

export const Header = styled.h1`
  display: block;
  margin: 0 0 20px 0;
  font-weight: 800;
  font-size: 1.5rem;
`;

export const ContentContainer = styled.div`
  max-width: ${screenXsMax};
  color: ${cssColorValue('textSubdued')};
  font-size: 1rem;
  line-height: 1.5;

  a {
    color: inherit;
  }
`;

export const PodcastName = styled.span`
  display: inline-block;
  font-weight: bold;
`;

export const ButtonContainer = styled.div`
  margin-top: 30px;
  button {
    white-space: nowrap;
  }
`;

export const StyledWarningMessage = styled(WarningMessage)`
  margin-top: 32px;
`;
